import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
import { classNames } from "../../../utils";
export const PolygonLogo = t0 => {
  const $ = _c(22);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== size) {
    t5 = {
      width: size,
      height: size
    };
    $[9] = size;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== fill) {
    t6 = fillVariants({
      fill
    });
    $[11] = fill;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== fillAttribute || $[14] !== t6) {
    t7 = <path className={t6} d="M9.002 8.516 6.752 7.21 0 11.13v7.816l6.751 3.908 6.752-3.908V6.791l3.746-2.17 3.746 2.17v4.34L17.249 13.3l-2.25-1.307v3.477l2.25 1.307L24 12.869V5.053l-6.751-3.908-6.752 3.908v12.155l-3.746 2.17-3.746-2.17v-4.353l3.746-2.17 2.25 1.308z" fill={fillAttribute} />;
    $[13] = fillAttribute;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== fillAttribute || $[17] !== rest || $[18] !== t4 || $[19] !== t5 || $[20] !== t7) {
    t8 = <svg className={t4} fill={fillAttribute} style={t5} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t7}</svg>;
    $[16] = fillAttribute;
    $[17] = rest;
    $[18] = t4;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};